import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_IOT_ZARIZENI_URL, ADMIN_IOT_ZARIZENI_BY_ID_URL, ADMIN_IOT_ZARIZENI_NEZARAZENA_URL, ADMIN_IOT_ZARIZENI_NOVA_URL,
    ADMIN_IOT_ZARIZENI_KANALY_URL, ADMIN_IOT_ZARIZENI_KANAL_URL,
    ADMIN_IOT_ZARIZENI_PRAVIDLO_URL, ADMIN_IOT_ZARIZENI_OVLADANI_URL, ADMIN_IOT_ZARIZENI_PRIKAZY_URL,
    ADMIN_IOT_ZARIZENI_STAV_URL, ADMIN_IOT_ZARIZENI_ROZPOZNAT_URL, ADMIN_IOT_KATALOG_URL,
} from "../url";

export type TypKanalu = 'switch' | 'light' | 'cover';
export type AkcePravidla = 'ZAPNOUT_NA_MINUT' | 'PULS' | 'ZAPNOUT_DO_KONCE' | 'VYPNOUT'
    | 'COVER_OTEVRIT' | 'COVER_ZAVRIT' | 'COVER_STOP' | 'COVER_POZICE';
export type Protokol = 'SHELLY_MQTT' | 'ZIGBEE' | 'SIA';

type BarvaStitku = 'success' | 'warning' | 'error' | 'default';
/**
 * Stav schválení zařízení správcem systému (jediné místo pro tyto texty). Schvaluje a zamítá jen správce
 * v MQTT dashboardu; jednotka schválení nikdy nemění, neschválené zařízení jen upozorní (ne blokace).
 * `label`/`color` = obecný štítek; `labelKarta`/`barvaKarta` = štítek v kartě zařízení, výstupu a v evidenci
 * (SCHVALENO se tam nezobrazuje); `labelFronta`/`barvaFronta` = sloupec schválení ve frontě Nová zařízení.
 * null ve stavu = server pro zařízení nedostupný nebo se zařízení ještě neozvalo (bez štítku).
 */
export const SCHVALENI: Record<string, {
    label: string; color: BarvaStitku; labelKarta: string; barvaKarta: 'default' | 'warning' | 'error';
    labelFronta: string; barvaFronta: 'default' | 'warning' | 'error';
}> = {
    SCHVALENO: { label: 'Schváleno', color: 'success', labelKarta: 'Schváleno', barvaKarta: 'default', labelFronta: 'Schváleno', barvaFronta: 'default' },
    NOVE: {
        label: 'Čeká na schválení správcem systému', color: 'warning', labelKarta: 'Čeká na schválení správcem systému', barvaKarta: 'warning',
        labelFronta: 'Čeká na schválení správcem systému', barvaFronta: 'warning',
    },
    ZAMITNUTO: {
        label: 'Zamítnuto správcem systému', color: 'error', labelKarta: 'Zamítnuto správcem systému', barvaKarta: 'error',
        labelFronta: 'Zamítnuto správcem systému', barvaFronta: 'default',
    },
};
/** Vysvětlení u štítků Čeká na schválení / Zamítnuto (tooltip). */
/** Podpora ovládání: jediný zdroj textů pro dialog, záložku Zařízení i menu karty. */
export const PODPORA_OVLADANI_KRATCE = 'Zatím jde přidávat a ovládat jen zařízení Shelly.';
export const PODPORA_OVLADANI = PODPORA_OVLADANI_KRATCE;

/** Přidání zařízení je dočasně omezené na Shelly (BE vrací stejný text jako 400 u ZIGBEE, SIA i cizího výrobce). */
export const ZATIM_JEN_SHELLY = 'Zatím jde přidat jen zařízení Shelly.';

// TODO HO-163: po overeni EPS/EZS (SIA) povolit pridavani ústředen
export const POVOLIT_PRIDANI_SIA = false;
// TODO HO-164: po overeni Zigbee (Raspberry Pi) povolit pridavani Zigbee cidel
export const POVOLIT_PRIDANI_ZIGBEE = false;

export const VYSVETLENI_SCHVALENI = 'Zařízení povoluje správce systému Hasiči Online. Do té doby může být ovládání omezené.';

export const KATEGORIE: Record<string, string> = {
    ZASUVKA: 'Zásuvka', MODUL_1K: 'Modul pod vypínač', MODUL_2K: 'Dvoukanálový modul', STMIVAC: 'Stmívač',
    VSTUPY: 'Vstupy', MERIC: 'Měřič', DETEKTOR_KOURE: 'Detektor kouře', ZIGBEE_SENZOR: 'Zigbee senzor',
    SIA_USTREDNA: 'Ústředna EPS/EZS', JINE: 'Jiné',
};

/** Spec katalogu 4.3: akce pravidla podle typu komponenty. */
export const AKCE_PRO_TYP: Record<TypKanalu, AkcePravidla[]> = {
    switch: ['ZAPNOUT_DO_KONCE', 'ZAPNOUT_NA_MINUT', 'PULS', 'VYPNOUT'],
    light: ['ZAPNOUT_DO_KONCE', 'ZAPNOUT_NA_MINUT', 'VYPNOUT'],
    cover: ['COVER_OTEVRIT', 'COVER_ZAVRIT', 'COVER_STOP', 'COVER_POZICE'],
};

/**
 * Ruční akce v menu Ovládat (spec UX IoT 4.3). Tři tečky = následuje dialog s parametrem.
 * COVER_STOP je u rolety samostatné tlačítko Zastavit bez potvrzení.
 */
export const RUCNI_AKCE_PRO_TYP: Record<TypKanalu, { akce: string; label: string }[]> = {
    switch: [{ akce: 'ZAPNOUT', label: 'Zapnout' }, { akce: 'VYPNOUT', label: 'Vypnout' },
             { akce: 'ZAPNOUT_NA_MINUT', label: 'Zapnout na dobu…' }, { akce: 'PULS', label: 'Puls…' }],
    light: [{ akce: 'ZAPNOUT', label: 'Rozsvítit…' }, { akce: 'VYPNOUT', label: 'Zhasnout' }, { akce: 'ZAPNOUT_NA_MINUT', label: 'Rozsvítit na dobu…' }],
    cover: [{ akce: 'COVER_OTEVRIT', label: 'Otevřít' }, { akce: 'COVER_ZAVRIT', label: 'Zavřít' },
            { akce: 'COVER_STOP', label: 'Zastavit' }, { akce: 'COVER_POZICE', label: 'Nastavit polohu…' }],
};

/** Puls dává smysl jen u modelu se suchým kontaktem; u neznámého modelu ho nabízíme také. */
export const pulsPovolen = (model: KatalogModel | undefined): boolean => !model || model.suchyKontakt;

export interface IotPravidlo { akce: AkcePravidla; parametr: number | null; vcetneTestu: boolean; poKonci: 'VRATIT' | 'NECHAT'; aktivni: boolean; }
export interface IotKanal { id: number; komponenta: string; typ: TypKanalu; nazev: string; aktivni: boolean; pravidlo: IotPravidlo | null; }
export interface IotZarizeni {
    id: number; objektId: number; protokol: Protokol; identifikator: string; gatewayId: string | null;
    identitaNedoresena: boolean; modelKod: string | null; kategorie: string; vyrobce: string | null; modelNazev: string | null;
    nazev: string; umisteni: string | null; vyrobniCislo: string | null; datumInstalace: string | null; poznamka: string | null;
    senzorId: number | null; siaAccountId: number | null; aktivni: boolean; overeno: boolean | null;
    /** SCHVALENO / NOVE / ZAMITNUTO podle serveru pro zařízení; null = nedostupný server nebo se zařízení neozvalo. */
    stavSchvaleni: string | null; kanaly: IotKanal[];
    /** Pozůstatek zrušené fronty předání (starší BE ho ještě může posílat); web ho nečte. */
    predaniCeka?: boolean; posledniChyba?: string | null;
    /**
     * Stav spojení z evidence (spec UX IoT K11a): Shelly/Zigbee ze snímku gatewaye, navázané čidlo podle kontaktu
     * do 30 min, ústředna SIA podle stavu účtu. null = nevíme (gateway nedostupná, zařízení se neozvalo).
     */
    online?: boolean | null; posledniKontaktEpochMs?: number | null;
}
export interface IotZarizeniRequest {
    objektId: number; protokol: Protokol; identifikator: string; gatewayId?: string | null; modelKod?: string | null;
    kategorie?: string | null; vyrobce?: string | null; modelNazev?: string | null; nazev: string; umisteni?: string | null;
    vyrobniCislo?: string | null; datumInstalace?: string | null; poznamka?: string | null; aktivni: boolean;
    kanaly?: { komponenta: string; nazev: string }[]; senzorId?: number | null; siaAccountId?: number | null;
    /** Identita načtená do formuláře při úpravě; BE podle ní pozná, že se mezitím změnila. */
    puvodniIdentifikator?: string | null; puvodniGatewayId?: string | null;
}
export interface NezarazenySenzor { id: number; objektId: number; zigbeeId: string | null; typ: string | null; nazev: string | null; }
export interface NezarazenaSia { id: number; objektId: number; accountId: string; panelType: string | null; nazev: string | null; }
export interface KatalogModel {
    kod: string; vyrobce: string; nazev: string; kategorie: string; protokol: Protokol; shellyApp: string | null;
    mereni: boolean; suchyKontakt: boolean; maxZatezW: number | null; overeno: boolean;
    komponenty: { profil: string; komponenta: string }[];
}
export interface NoveZarizeni {
    objektId: number; zdroj: 'SHELLY' | 'ZIGBEE'; zarizeniId: string; zigbeeId: string | null; stav: string;
    schvalil: string | null; modelKod: string | null; rozpoznanyModel: string | null; typ: string | null;
    prvniKontaktEpochMs: number | null; posledniKontaktEpochMs: number | null;
}
export interface StavKanalu {
    komponenta: string; faze: string; vystup: boolean | null; hodnota: number | null; stavText: string | null;
    apowerW: number | null; napetiV: number | null; proudA: number | null; ucinik: number | null; frekvenceHz: number | null;
    energieWh: number | null; chyby: string | null; casZarizeniEpochMs: number | null; zmenenoEpochMs: number | null;
}
export interface StavZarizeni {
    online: boolean | null; posledniKontaktEpochMs: number | null; modelKod: string | null; profil: string | null;
    komponenty: string[]; rozpoznanoEpochMs: number | null; rozpoznaniChyba: string | null; kanaly: StavKanalu[];
}
export interface VysledekOvladani { success: boolean; stav: string; wasOn: boolean | null; poznamka: string | null; message?: string; }
export interface FiltrEvidence { q?: string; objektId?: number; kategorie?: string; vyrobce?: string; neovereno?: boolean; neschvaleno?: boolean; nedoresena?: boolean; }

/** Ovladane komponenty (vstupy a merice se nevytvareji jako kanaly). */
export const OVLADANA = /^(switch|light|cover):[0-3]$/;

const VYCHOZI_NAZEV_TYPU: Record<string, string> = { switch: 'Výstup', light: 'Světelný výstup', cover: 'Roleta' };

/**
 * Výchozí název výstupu podle komponenty, stejný jako nazevVystupu v iotStav (spec UX IoT 1.4):
 * switch:0 -> Výstup 1, light:0 -> Světelný výstup 1, cover:0 -> Roleta 1. Neznámý typ -> Výstup N.
 */
export const vychoziNazevKanalu = (komponenta: string): string => {
    const [typ, cislo] = komponenta.split(':');
    return `${VYCHOZI_NAZEV_TYPU[typ] ?? 'Výstup'} ${Number(cislo) + 1}`;
};

/** Komponenty, ktere z modelu katalogu vzniknou jako ovladane kanaly (bez vstupu a mericu). */
export const ovladateleKomponenty = (m: KatalogModel | undefined, profil = ''): string[] =>
    (m?.komponenty ?? []).filter((k) => (k.profil || '') === profil && OVLADANA.test(k.komponenta))
        .map((k) => k.komponenta);

const IotZarizeniService = {
    objektu: (objektId: number) => handleRequest<IotZarizeni[]>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_URL, { params: { objektId } })),
    hledej: (f: FiltrEvidence) => handleRequest<IotZarizeni[]>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_URL, { params: f })),
    vytvor: (d: IotZarizeniRequest) => handleRequest<IotZarizeni>(() => axiosInstance.post(ADMIN_IOT_ZARIZENI_URL, d)),
    uprav: (id: number, d: IotZarizeniRequest) => handleRequest<IotZarizeni>(() => axiosInstance.put(ADMIN_IOT_ZARIZENI_BY_ID_URL(id), d)),
    smaz: (id: number) => handleRequest<void>(() => axiosInstance.delete(ADMIN_IOT_ZARIZENI_BY_ID_URL(id))),
    pridejKanal: (id: number, k: { komponenta: string; nazev: string }) => handleRequest<IotKanal>(() => axiosInstance.post(ADMIN_IOT_ZARIZENI_KANALY_URL(id), k)),
    upravKanal: (id: number, kanalId: number, k: { komponenta: string; nazev: string; aktivni: boolean }) =>
        handleRequest<IotKanal>(() => axiosInstance.put(ADMIN_IOT_ZARIZENI_KANAL_URL(id, kanalId), k)),
    smazKanal: (id: number, kanalId: number) => handleRequest<void>(() => axiosInstance.delete(ADMIN_IOT_ZARIZENI_KANAL_URL(id, kanalId))),
    ulozPravidlo: (id: number, kanalId: number, p: IotPravidlo) => handleRequest<IotKanal>(() => axiosInstance.put(ADMIN_IOT_ZARIZENI_PRAVIDLO_URL(id, kanalId), p)),
    smazPravidlo: (id: number, kanalId: number) => handleRequest<void>(() => axiosInstance.delete(ADMIN_IOT_ZARIZENI_PRAVIDLO_URL(id, kanalId))),
    // Gateway ceka na zarizeni az 10 s, BE na gateway az 5 s connect + 45 s read: timeout musi byt nad tim.
    ovladej: (id: number, kanalId: number, akce: string, sekund?: number, hodnota?: number) =>
        handleRequest<VysledekOvladani>(() => axiosInstance.post(ADMIN_IOT_ZARIZENI_OVLADANI_URL(id, kanalId), { akce, sekund, hodnota }, { timeout: 55000 })),
    prikazy: (id: number, kanalId: number) => handleRequest<Record<string, unknown>[]>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_PRIKAZY_URL(id, kanalId), { params: { limit: 10 } })),
    stav: (id: number) => handleRequest<StavZarizeni>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_STAV_URL(id))),
    rozpoznat: (id: number) => handleRequest<void>(() => axiosInstance.post(ADMIN_IOT_ZARIZENI_ROZPOZNAT_URL(id))),
    katalog: () => handleRequest<KatalogModel[]>(() => axiosInstance.get(ADMIN_IOT_KATALOG_URL)),
    nova: () => handleRequest<NoveZarizeni[]>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_NOVA_URL)),
    nezarazena: () => handleRequest<{ senzory: NezarazenySenzor[]; sia: NezarazenaSia[] }>(() => axiosInstance.get(ADMIN_IOT_ZARIZENI_NEZARAZENA_URL)),
};

export default IotZarizeniService;
